import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FIRST_ELEMENT_INDEX, RICH_TEXT_TOOL_BAR_OPTIONS, USER_INPUT_DEBOUNCE_TIME } from '@modeso/aumico-lib-core-fe';
import { IRichText } from '@modeso/types__aumico-lib-notes-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { QuillModules } from 'ngx-quill';
import { debounceTime } from 'rxjs/operators';
import { ITranslationsTableData } from '../../interfaces/translations-table-data.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-notes-edit-notes-type-rich-text-translations',
    templateUrl: './edit-notes-type-rich-text-translations.component.html',
    styleUrls: ['./edit-notes-type-rich-text-translations.component.scss'],
})
export class EditNotesTypeRichTextTranslationsComponent implements OnInit {
    public formGroup: UntypedFormGroup | undefined;
    public translationsFormArray: UntypedFormArray | undefined;
    public displayedColumns: string[] = ['name', 'currentLocale', 'selectedLocale'];
    public toolbarOptions: QuillModules | undefined;
    public tableData: ITranslationsTableData[] = [];

    @Input() richTexts: IRichText[] | undefined;
    @Input() currentLocale = 'de-ch';
    @Input() selectedLocale: string | undefined;
    @Input() rowName: string | undefined;

    @Output() translationValuesChanged: EventEmitter<ITranslationsTableData> =
        new EventEmitter<ITranslationsTableData>();

    ngOnInit(): void {
        this.toolbarOptions = RICH_TEXT_TOOL_BAR_OPTIONS;
        this.mapRichTextsToTableData();
        this.initializeForm();
        this.monitorFormChanges();
    }

    private initializeForm(): void {
        this.formGroup = new UntypedFormGroup({
            ['currentLocale']: new UntypedFormControl(this.tableData[FIRST_ELEMENT_INDEX].currentLocale),
            ['selectedLocale']: new UntypedFormControl(this.tableData[FIRST_ELEMENT_INDEX].selectedLocale),
        });
    }

    private mapRichTextsToTableData() {
        let richTextValue: ITranslationsTableData = { currentLocale: null, selectedLocale: null };
        this.richTexts.forEach((richText) => {
            if (richText.language === this.currentLocale) {
                richTextValue.currentLocale = richText.text;
            } else if (richText.language === this.selectedLocale) {
                richTextValue.selectedLocale = richText.text;
            }
        });
        this.tableData.push(richTextValue);
    }

    private monitorFormChanges(): void {
        if (this.formGroup == null) {
            throw new Error('Form group is undefined.');
        }
        this.formGroup.valueChanges
            .pipe(debounceTime(USER_INPUT_DEBOUNCE_TIME), untilDestroyed(this))
            .subscribe((formValue) => {
                this.translationValuesChanged.emit(formValue);
            });
    }
}
